import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import level1 from "src/assets/images/creditScoreRank/rank1.png";
import level2 from "src/assets/images/creditScoreRank/rank2.png";
import level3 from "src/assets/images/creditScoreRank/rank3.png";
import level4 from "src/assets/images/creditScoreRank/rank4.png";
import level5 from "src/assets/images/creditScoreRank/rank5.png";
import TitleTypography from "src/components/Typography/TitleTypography";
import ScoringLoading from "src/components/utils/ScoringLoading";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useAnalysisSelector } from "src/context/analysisContext";
import { toFixed } from "src/services/utils";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const levelImage = [level1, level2, level3, level4, level5];

const useStyle = makeStyles((theme) => ({
  medalGrid: {
    background: theme.palette.background.subPaper,
    height: 265,
    borderRadius: "10px 0px 0px 10px",
    paddingTop: "2rem",
  },
  scoreText: {
    color: theme.palette.text.disabled,
    fontSize: "62px",
    fontWeight: 600,
  },
  minMaxFigure: {
    color: theme.palette.text.disabled,
  },
  paper: {
    padding: "0rem 1.5rem 0rem 0rem",
    height: 265,
  },
  root: {
    marginTop: "1.5rem",
  },
  flexItemContainer: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  image: {
    maxWidth: "75%",
    [theme.breakpoints.down("md")]: {
      maxWidth: "90%",
    },
  },
}));

export default function YourCreditScore() {
  const cls = useStyle();
  const account = useAnalysisSelector((state) => state.account);
  const { address } = useWeb3Connect();

  return (
    <PaperWrapper title="Your Credit Score (α-version)" className={cls.root} paperProps={{ className: cls.paper }}>
      {(() => {
        if (address) {
          if (account)
            return (
              <Grid container>
                <Grid item lg={4} md={5} xs={4}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-start"
                    alignItems="center"
                    className={cls.medalGrid}
                  >
                    <img src={levelImage[account.rank]} alt="medal" className={cls.image} />
                  </Box>
                </Grid>
                <Grid item lg={8} md={7} xs={8} style={{ padding: "2rem 1rem" }}>
                  <Box>
                    <Typography className={cls.scoreText}>{toFixed(account.current_score)}</Typography>
                    <Typography color="textSecondary">
                      You have reached Trava’s{" "}
                      <span style={{ fontSize: "16px", fontWeight: 500 }}>{account.level}</span> level
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" pt={7}>
                    <Box display="flex" className={cls.flexItemContainer}>
                      <Typography color="textSecondary" style={{ paddingRight: "0.5rem" }}>
                        Min score
                      </Typography>
                      <Typography className={cls.minMaxFigure} variant="subtitle1">
                        {account.min_score}
                      </Typography>
                    </Box>
                    <Box display="flex" className={cls.flexItemContainer}>
                      <Typography color="textSecondary" style={{ paddingRight: "0.5rem" }}>
                        Max score
                      </Typography>
                      <Typography className={cls.minMaxFigure} variant="subtitle1">
                        {account.max_score}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            );
          else return <ScoringLoading />;
        } else
          return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <TitleTypography textProps={{ variant: "h4" }} title="Please connect your wallet first!" />
            </Box>
          );
      })()}
    </PaperWrapper>
  );
}
